import './ExpansionPanel.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d",
    "root": "ExpansionPanel_root__b3dc6",
    "default": "ExpansionPanel_default__b3dc6",
    "container": "ExpansionPanel_container__b3dc6",
    "ghost": "ExpansionPanel_ghost__b3dc6",
    "trigger": "ExpansionPanel_trigger__b3dc6",
    "triggerText": "ExpansionPanel_triggerText__b3dc6",
    "content": "ExpansionPanel_content__b3dc6",
    "divider": "ExpansionPanel_divider__b3dc6"
};
